<template>
    <div id="auth_header" :style="{background: `linear-gradient(to right, ${colors.thirth} 0%, ${colors.first} 50%, ${colors.fourth} 100%)`}">
        <img :src="`/img/logo/${companyId}.png`" class="logo_company" alt="Logo">
    </div>
</template>

<script>
import firebase from "firebase";
export default {
    props: {
        companyId: {
            type: String,
            required: true
        }
    },

    data: () =>({
        colors: ''
    }),

    created(){
        this.colors = this.$store.getters.getCustomColors
    }
}
</script>

<style lang="scss" scoped>
    #auth_header{
        height: 10vh;
        background: #a71d69;
        background: linear-gradient(to right, #a71d69 0%, #da0335 50%, #d35555 100%);
        display: flex;
        justify-content: center;
        align-items: center;

        .logo_company{
            max-width: 120px;
            margin-bottom: 10px;
        }
    }
</style>
